export enum MFAMessageSentEnum {
  DEFAULT = 'Invalid or expired code',
  FIRST_ATTEMPT = 'You have 2 attempts left',
  SECOND_ATTEMPT = 'You have 1 attempts left',
  THIRD_ATTEMPT = 'MFA blocked',
}
